export default {
  share: { id: 'rm_share_button_share', defaultMessage: 'Share' },
  copied: { id: 'rm_share_button_copied', defaultMessage: 'Copied!' },
} as const
